export default '/build/455913d2.svg'